interface SearchConfig {
  filterKey?: string;
  filterValue?: string;
  options?: string;
  pageLimit?: string;
}

interface ProductFilter {
  underRetail?: boolean;
  inStock?: boolean;
  priceCentsMin?: string;
  priceCentsMax?: string;
  pageLimit?: string;
  instantShip?: boolean;
}

export const getConsumerSearchParams = (searchConfig: SearchConfig): ProductFilter => {
  const params: ProductFilter = {};

  // handle filterKey and filterValue
  if (searchConfig.filterKey === 'discount_tag') {
    params.underRetail = true;
  }

  const optionPairs = searchConfig.options.split('&');
  // handle page limit
  const pageLimit = optionPairs.find((option) => option.startsWith('num_results_per_page'));

  if (pageLimit) {
    params.pageLimit = pageLimit?.split('=')?.[1];
  }

  if (searchConfig.options) {
    // handle options string (format: filters[color]=black&filters[brand]=dior)
    const filterRegex = /filters\[(?<key>\w+)]=(?<value>[^&]+)/;

    for (const pair of optionPairs) {
      const match = pair.match(filterRegex);
      if (!match?.groups) continue;

      const { key, value } = match.groups;

      switch (key) {
        case 'discount_tag':
          params.underRetail = true;
          break;
        case 'is_in_stock':
          params.inStock = true;
          break;
        case 'instant_ship_lowest_price_cents':
          params.instantShip = true;
          break;
        case 'lowest_price_cents': {
          const [min, max] = value.split('-');
          if (min && max) {
            params.priceCentsMin = min;
            params.priceCentsMax = max;
          }
          break;
        }

        default:
          // Ignore unknown filter keys
          break;
      }
    }
  }

  return params;
};
